import React, { useEffect, useState } from 'react';
import { Table, Button, Drawer, Space, Popconfirm, message, Card, Input } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { ServicetypeService } from '../../../Services/Manage/ServicetypeService';
import useMessage from 'antd/es/message/useMessage';
import dayjs from 'dayjs';
import AddProducts from './AddProducts';

const ViewProducts = () => {
    const [data, setData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editingRecord, setEditingRecord] = useState(null);
    const [message, smsgContext] = useMessage();
    const [proCat, setProcat] = useState([]);


    const getAllServices = async () => {
        try {
            const request = await ServicetypeService.getAllProducts();
            const formattedData = request.data.map((item, index) => ({
                ...item,
                si_no: index + 1,
                key: item.id,
            }));

            setData(formattedData);
            setOriginalData(formattedData);

        } catch (error) {
            console.error(error);

        }
    };
    useEffect(() => {
        getAllServices();
        getallcat();
    }, [])

    const getallcat = async () => {
        try {
            const request = await ServicetypeService.getAllProductCat();

            setProcat(
                request.data.map((p) => ({
                    value: p.id,
                    label: p.name
                }))
            )

        } catch (error) {
            console.error(error);

        }
    }


    // Open drawer for Add
    const handleAdd = () => {
        setEditingRecord(null);
        setDrawerOpen(true);
    };

    // Open drawer for Edit
    const handleEdit = (record) => {
        setEditingRecord(record);
        setDrawerOpen(true);
    };

    // Handle form submit (add or edit)
    const handleSubmit = (values) => {
        if (editingRecord) {
            // Edit existing
            setData((prev) =>
                prev.map((item) =>
                    item.key === editingRecord.key ? { ...item, ...values } : item
                )
            );
            getAllServices();
        } else {
            // Add new
            const newRecord = {
                key: Date.now().toString(),
                ...values,
                added_on: new Date().toISOString().slice(0, 16).replace("T", " "),
                updated_on: new Date().toISOString().slice(0, 16).replace("T", " "),
            };
            setData((prev) => [...prev, newRecord]);
            getAllServices();
        }
        setDrawerOpen(false);
    };


    const handleDelete = async (key) => {
        console.log(key);

        try {
            const req = await ServicetypeService.deleteProducts(key);
            console.log(req);

            if (req.status) {
                message.success(req.message)
                getAllServices();
                setData((prev) => prev.filter((item) => item.key !== key));
            } else {
                message.error(req.message)
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleSearch = (value) => {
        setSearchText(value);

        if (!value) {
            setData(originalData);
            return;
        }

        const filteredData = originalData.filter((item) =>
            Object.values(item).some((field) =>
                field
                    ?.toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
            )
        );

        setData(filteredData);
    };

    const columns = [
        { title: 'S. No', dataIndex: 'si_no', key: 'si_no', width: 70 },

        {
            title: 'Product Name',
            dataIndex: 'name',
            key: 'name',
            width: 100,
            ellipsis: true,
            render: (text) => {
                if (!text) return '-';
                return text.length > 100 ? `${text.slice(0, 60)}...` : text;
            },
        },

        { title: 'HSN/SAC Code', dataIndex: 'sku', key: 'sku', width: 120 },
        { title: 'Unit', dataIndex: 'unit', key: 'unit', width: 100 },
        { title: 'Unit Price', dataIndex: 'unit_price', key: 'unit_price', width: 120 },
        // { title: 'Note', dataIndex: 'note', key: 'note' },
        {
            title: 'Updates', dataIndex: 'updated_on', key: 'updated_on',
            render: (_, record) => (
                <div>
                    <div>
                        <strong>Added On:</strong>{" "}
                        {record.added_on
                            ? dayjs(record.added_on).format("DD-MM-YYYY hh:mm A")
                            : "-"}
                    </div>
                    <div>
                        <strong>Updated On:</strong>{" "}
                        {record.updated_on
                            ? dayjs(record.updated_on).format("DD-MM-YYYY hh:mm A")
                            : "-"}
                    </div>
                </div>
            ),
        },
        {
            title: 'Actions',
            key: 'actions',
            fixed: 'right',
            render: (_, record) => (
                <Space>
                    <Button
                        size='large'
                        icon={<EditOutlined />}
                        onClick={() => handleEdit(record)}
                    />
                    <Popconfirm
                        title="Are you sure to delete?"
                        onConfirm={() => handleDelete(record.id)}
                    >
                        <Button size='large' danger icon={<DeleteOutlined />} />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <Card
            title='Manage Products' ViewProducts
            extra={
                <Space>

                    <Input
                        size="large"
                        placeholder="Search products..."
                        style={{ width: 350 }}
                        value={searchText}
                        onChange={(e) => handleSearch(e.target.value)}
                        allowClear
                    />

                    <Button
                        size='large'
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={handleAdd}
                    >
                        Add Products
                    </Button>
                </Space>
            }>

            <Table
                columns={columns}
                dataSource={data}
                pagination={{  pageSize: 7 }}
                scroll={{ x: 'max-content' }}
            />
            {smsgContext}

            <Drawer
                title={editingRecord ? 'Edit Product' : 'Add Product'}
                width={450}
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                destroyOnClose
            >
                <AddProducts
                    proCat={proCat}
                    initialValues={editingRecord}
                    onSubmit={handleSubmit}
                    onCancel={() => setDrawerOpen(false)}
                    getallcat={getallcat}
                />
            </Drawer>
        </Card>
    );
};

export default ViewProducts;
